module.exports = __webpack_public_path__ + "static/media/9S.0fd22f63.svg";